import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { PinmonkeyLobby, Pinmonkey, PinmonkeyEditor, QuestEditor } from 'containers'

export const PinmonkeyRouter = () => {
  return (
    <Routes>
      <Route index element={<PinmonkeyLobby />} />
      <Route path=":slug" element={<Pinmonkey />} />
      <Route path="edit" element={<PinmonkeyEditor />} />
      <Route path=":slug/edit" element={<PinmonkeyEditor />} />
      <Route path="quests" element={<QuestEditor />} />
    </Routes>
  )
}
